/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import $http from '../plugins/axios';

const getPreAuthUrl = async (url: any, data: any) => {
  // try {
  //   let preSignedurl;
  //   await $http.post(url, data).then((response: any) => {
  //     console.log('prsigned Response', response);
  //     preSignedurl = response.data.preSignedUrl;
  //     return preSignedurl;
  //   });
  //   return preSignedurl;
  // } catch (error) {
  //   return error;
  // }
  const preSignedurl = await $http.post(url, data);
  // preSignedurl = response.data.preSignedUrl;
  return preSignedurl;
};
const learnerTaskToReview = async (url: any) => {
  const learnerTaskRes = await $http.get(url);
  return learnerTaskRes;
};
const learnerTaskToProxyReview = async (learnerTaskId: string) => {
  // try {
  //   let learnerTaskRes;
  //   await $http.get(`learnerTaskToProxyReview/${learnerTaskId}`).then((response) => {
  //     console.log('response from api', response);
  //     learnerTaskRes = response.data;
  //     return learnerTaskRes;
  //   });
  //   return learnerTaskRes;
  // } catch (error) {
  //   return error;
  // }
  const learnerTaskRes = await $http.get(`learnerTaskToProxyReview/${learnerTaskId}`);
  return learnerTaskRes;
};
const saveReview = async (url: any, data: any) => {
  // try {
  //   let savedRes;
  //   await $http.post(url, data).then((response: any) => {
  //     savedRes = response.data;
  //     return savedRes;
  //   });
  //   return savedRes;
  // } catch (error) {
  //   return error;
  // }
  const savedRes = await $http.post(url, data);
  return savedRes;
};
const downloadLearnerSubmission = async (urlToDownloadSusbmission: string, learnerSubmission: string) => {
  console.log(learnerSubmission);
  console.log(urlToDownloadSusbmission);
  const fileToDownload = await fetch(urlToDownloadSusbmission);
  const fileBlob = await fileToDownload.blob();
  const urlToInvoke = URL.createObjectURL(fileBlob);
  const anchor = document.createElement('a');
  anchor.setAttribute('download', learnerSubmission);
  anchor.href = urlToInvoke;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(urlToInvoke);
  // const myRequest = new Request(urlToDownloadSusbmission, {
  //   method: 'GET',
  //   headers: {
  //     'X-Requested-By': 'XMLHttpRequest',
  //     'Content-Type': 'application/json',
  //   },
  //   mode: 'no-cors',
  //   cache: 'default',
  // });
  // fetch(myRequest).then((response: any) => {
  //   const fileURL = window.URL.createObjectURL(new Blob([response.data]));
  //   const fileLink = document.createElement('a');
  //   fileLink.href = fileURL;
  //   fileLink.setAttribute('download', learnerSubmission);
  //   document.body.appendChild(fileLink);

  //   fileLink.click();
  // });
};
export const plagiarismSubmissionUPload = async (url: any, bulkTaskFile: any) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'put',
      body: bulkTaskFile,
    });
    const uploadResponse = res;
    return uploadResponse;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export { getPreAuthUrl, learnerTaskToReview, saveReview, learnerTaskToProxyReview, downloadLearnerSubmission };
